import Partners from "../../features/partners/Partners";

export default function PartnersPage() {
  return (
    <div>
      <Partners />
    </div>
  );
}
